import "./edit-patient.scss";

import DashboardCard from "@shared/ui/dashboard-card/dashboard-card";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { currencyFormat } from "@shared/utility/formats/currency-format";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Menubar } from "primereact/menubar";
import { FormProvider } from "react-hook-form";
import { FaCoins, FaMoneyBillWave, FaWallet } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa6";
import { Outlet } from "react-router-dom";

import { useEditPatient } from "./edit-patient.hook";

export function EditPatient() {
  const {
    patientData,
    isLoading,
    patientError,
    formMethod,
    actions,
    menuItems,
    handleBack,
    handleAction,
    isExactPatientRoute,
    contractData,
    totalAmount,
    totalBalance,
    totalContracts,
  } = useEditPatient();

  const title = patientData?.first_name ? (
    <h1>
      {patientData?.first_name} {patientData?.last_name}
    </h1>
  ) : (
    <h1>Edit Patient</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <section className="grid grid-cols-1 gap-2 mb-4">
      <Menubar model={menuItems} />

      <div className="mt-4">
        <Outlet />
      </div>
    </section>
  );

  const summary = contractData?.length > 0 && (
    <div className="flex flex-wrap gap-4 mb-6">
      <div className="flex-1 min-w-[250px]">
        <DashboardCard
          model={{
            title: "Total Amount",
            value: currencyFormat(totalAmount, "PHP"),
            icon: <FaMoneyBillWave className="text-blue-600 text-2xl" />,
            iconClass: "bg-blue-100",
            description: "",
          }}
        />
      </div>

      <div className="flex-1 min-w-[250px]">
        <DashboardCard
          model={{
            title: "Total Remaining Balance",
            value: currencyFormat(totalBalance, "PHP"),
            icon: <FaWallet className="text-red-500 text-2xl" />,
            iconClass: "bg-red-100",
            description: "",
          }}
        />
      </div>

      <div className="flex-1 min-w-[250px]">
        <DashboardCard
          model={{
            title: "Total Contracts",
            value: totalContracts.toString(),
            icon: <FaCoins className="text-green-600 text-2xl" />,
            iconClass: "bg-green-100",
            description: "",
          }}
        />
      </div>
    </div>
  );

  return (
    <div id="EditPatient" className="patient">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        {isExactPatientRoute && (
          <HeaderButton actions={actions} onAction={handleAction} />
        )}
      </HeaderContent>

      <section className="p-7">
        {summary}
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {patientError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditPatient;
